import {
	FETCH_SURVEY_ESTABLISHMENTS_START,
	FETCHED_SURVEY_ESTABLISHMENTS_SUCCESS,
	SELECT_SURVEY_ESTABLISHMENT,
	ANYWHERE_PARAM_ESTABLISHMENT,
	START_WITH_PARAM_ESTABLISHMENTS,
    SIGNED_SEARCH,
    REJECTED_SEARCH,
    APPROVED_SEARCH,
    SignedStates,
    RejectedStates,
    ApprovedStates
} from "./EstablishmentsActions";



const establishmentsReducer = (state = { surveyEstablishments: [], isFetching: false, isResultFetched: false, count: 0, 
    currentPage: 0, searchAnywhereParam: "", startWithParam: "", 
    signedSearch: SignedStates.ALL, 
    rejectedSearch: RejectedStates.ALL,     
    approvedSearch: ApprovedStates.ALL 
}, action) => {

    switch (action.type) {
        case FETCH_SURVEY_ESTABLISHMENTS_START:
            return {
                ...state,
                isFetching: true,
                isResultFetched: false,
                currentPage: action.first ? 0 : (state.currentPage + 1),
                surveyEstablishments: action.first ? [] : state.surveyEstablishments,
                activeLangCodeOfPages: action.first ? action.activeLangCode : state.activeLangCodeOfPages
            }
        case FETCHED_SURVEY_ESTABLISHMENTS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                isResultFetched: true,
                surveyEstablishments: state.currentPage === 0 ? action.surveyEstablishments.register : [...state.surveyEstablishments, ...action.surveyEstablishments.register],
                count: action.surveyEstablishments.paging.count,
            }
        case SELECT_SURVEY_ESTABLISHMENT:
            return {
                ...state,
                surveyEstablishments: state.surveyEstablishments.map((establishment) => {
                    if (establishment.id === action.surveyEstablishmentId) {
                        return { ...establishment, selected: true }
                    } else {
                        return { ...establishment, selected: false }
                    }
                })
            }
        case ANYWHERE_PARAM_ESTABLISHMENT:
            return {
                ...state,
                searchAnywhereParam: action.searchAnywhereParam
            }
        case START_WITH_PARAM_ESTABLISHMENTS:
            return {
                ...state,
                startWithParam: action.startWithParam
            }
        case SIGNED_SEARCH:
            return {
                ...state,
                signedSearch: action.signedSearch
            }
            case REJECTED_SEARCH:
                return {
                    ...state,
                    rejectedSearch: action.rejectedSearch
                }            
        case APPROVED_SEARCH:
            return {
                ...state,
                approvedSearch: action.approvedSearch
            }
        default:
            return state;
    }
}

export default establishmentsReducer;


// WEBPACK FOOTER //
// ./src/features/modules/dynamic-survey/establishments/EstablishmentsReducer.js